export default __webpack_public_path__ + "static/stefan-30f45c867f0ccf7c9c800572eb0eedd1.png";